import { IconProps } from '../types';

function DuplicatePencilSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      className={className || 'h-5 w-5'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M16 6H8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.7 16H8v-1.7l4.1-4.1 1.8 1.7L9.7 16zm5.9-6l-.6.7L13.3 9l.7-.6c.5-.5 1.2-.5 1.7 0 .3.4.3 1.2-.1 1.6zM4 14c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2H4v10z" />
    </svg>
  );
}

export default DuplicatePencilSolidIcon;
